import * as types from './mutation-types.js'
import {SET_TABLES_STATUS} from "@/store/modules/table/mutation-types";

export const loadReservations = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('/get/reservations').then((response) => {
            commit(types.ADD_RESERVATIONS, response.data.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const loadRestaurantReservations = ({ commit, dispatch, state }, restaurant_id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/restaurant/${restaurant_id}/reservations`).then((response) => {
            commit(types.ADD_RESERVATIONS, response.data.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const loadReservation = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`show/${id}/reservation`).then((response) => {
            commit(types.LOAD_RESERVATION, response.data.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const validateReservation = ({commit, dispatch, state}, data) => {

    return new Promise((resolve, reject) => {
        window.axios.patch('validate/' + data.reservation_id + '/reservation', data).then((response) => {
            commit(types.SET_RESERVATION, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const cancelReservation = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('cancel/' + data + '/reservation').then((response) => {
            commit(types.SET_RESERVATION, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const deleteReservation = ({ commit, dispatch, state }, { id }) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`delete/restaurant/${id}/reservation`).then((response) => {
            commit(types.REMOVE_RESERVATION, id)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}


export const updateReservation = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        axios.patch('update/restaurant/' + data.id + '/reservation', data).then((response) => {
            commit(types.SET_RESERVATION, response.data.data)
            commit('table/' + SET_TABLES_STATUS, response.data.data.tables, {root: true})
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}